import { render, staticRenderFns } from "./AppendixRecall.vue?vue&type=template&id=05f59ef2&scoped=true"
import script from "./AppendixRecall.vue?vue&type=script&lang=js"
export * from "./AppendixRecall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f59ef2",
  null
  
)

export default component.exports